import queryString from 'utils/queryString';
import { apiClientGetRequest, apiClientPostRequest, apiClientPutRequest } from '../lib/backendRequest';
import SETTINGS from '../settings';

const uploadSessionsApi = (accessToken = undefined) => ({
  create: async () => {
    try {
      const response = await apiClientPostRequest(
        queryString.stringifyUrl('api/v1/upload_sessions/new', {
          client_id: SETTINGS.CLIENT_ID,
        }),
        {},
        {
          Authorization: `Token ${accessToken}`,
        },
      );

      const json = await response.json();

      return { data: json.data };
    } catch (error) {
      return { error };
    }
  },

  getData: async (sessionId) => {
    try {
      const response = await apiClientGetRequest(
        queryString.stringifyUrl(`api/v1/upload_sessions/${sessionId}`, {
          client_id: SETTINGS.CLIENT_ID,
        }),
      );

      const json = await response.json();

      return { data: json.data };
    } catch (error) {
      return { error };
    }
  },

  putPhoto: async (sessionId, photo) => {
    try {
      const response = await apiClientPutRequest(
        queryString.stringifyUrl(`api/v1/upload_sessions/${sessionId}`, {
          client_id: SETTINGS.CLIENT_ID,
        }),
        { url: photo },
      );

      const json = await response.json();

      return { data: json.data };
    } catch (error) {
      return { error };
    }
  },
});

export default uploadSessionsApi;
